import { differenceInMonths } from 'date-fns';
import { useLocale } from '@adsk/alloy-react-locale';
import { SHORT } from './consts';
import { displayDate } from './displayDate';
import { getValidLocale } from './helpers';

/**
 * `useDateRange` takes two `Date` objects, and returns a string representing the date range between the inputs.
 * For dates that have a span of a year or greater, years will be displayed. Otherwise, years are omitted.
 * @param startDate - `Date` object representing the beginning of the range.
 * @param endDate - `Date` object representing the end of the range.
 * @param options - options object can contain following fields:
 *   * `format` - either "default", "short", or "numeric".
 *   * `locale` - developer designated locale (this will take precedence over browser setting, if language differs).
 * @returns a string representing the beginning and end of a date range.
 */
const useDateRange = (startDate, endDate, options) => {
  const diffMonths = differenceInMonths(endDate, startDate);
  const showYears = Math.abs(diffMonths) < 12 ? false : true;
  const {
    T
  } = useLocale(_ref => {
    let {
      locale
    } = _ref;
    return require(`./i18n/${options !== null && options !== void 0 && options.locale ? getValidLocale(options.locale) : locale}.json`);
  });
  return T.translate('FROM_TO', {
    start: displayDate(startDate, {
      format: SHORT,
      utc: false,
      year: showYears
    }),
    end: displayDate(endDate, {
      format: SHORT,
      utc: false,
      year: showYears
    })
  });
};
export default useDateRange;
//# sourceMappingURL=useDateRange.js.map